import type { ReactNode } from 'react';

import { Box, Card, Stack, Typography } from '@mui/material';

export interface ComposerCardProps {
  /** Small, before the title: the live dot, or a pencil. */
  mark: ReactNode;
  title: string;
  /** On the right of the header, such as a way to stop. */
  action?: ReactNode;
  children: ReactNode;
}

/**
 * ComposerCard holds text above the bar that is about to go: what a recording
 * is saying, or a card's lines being corrected, so text on its way always
 * looks the same.
 */
export const ComposerCard = ({
  mark,
  title,
  action,
  children,
}: ComposerCardProps) => (
  <Card variant='padded' sx={{ width: '100%' }}>
    <Stack spacing={1.5}>
      <Stack direction='row' spacing={1} sx={{ alignItems: 'center' }}>
        <Box sx={{ display: 'flex', flexShrink: 0 }}>{mark}</Box>
        <Typography variant='subtitle1' sx={{ flex: 1 }}>
          {title}
        </Typography>
        {action}
      </Stack>
      {children}
    </Stack>
  </Card>
);

ComposerCard.displayName = 'ComposerCard';
export default ComposerCard;
